module.exports = __webpack_public_path__ + "media/placeholder-mobile-7b16dec4.jpg";